import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

let error = {
  theme: 'bubble',
  type: 'error',
  className: 'toasted__error',
  position: 'bottom-right',
  duration: '5000'
  // action: {
  //   text: 'Cancel',
  //   onClick: (e, toastObject) => {
  //     toastObject.goAway(0)
  //   }
  // }
}

let success = {
  theme: 'bubble',
  type: 'success',
  className: 'toasted__succes',
  position: 'bottom-right',
  duration: '5000'
  // action: {
  //   text: 'Cancel',
  //   onClick: (e, toastObject) => {
  //     toastObject.goAway(0)
  //   }
  // }
}

let info = {
  theme: 'bubble',
  type: 'info',
  className: 'toasted__info',
  position: 'bottom-right',
  duration: '5000'
}

Vue.toasted.register('error_message',
  (payload) => {
    // if there is no message passed show default message
    if (!payload.message) {
      return 'Oops.. Something Went Wrong..'
    }

    // if there is a message show it with the message
    return payload.message
  },
  error
)

Vue.toasted.register('success_message',
  (payload) => {
    // if there is no message passed show default message
    if (!payload.message) {
      return 'Success!'
    }

    // if there is a message show it with the message
    return payload.message
  },
  success
)

Vue.toasted.register('info_message',
  (payload) => {
    if (!payload.message) {
      return 'Info'
    }

    return payload.message
  },
  info
)
